import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled, { prop } from '@nobia/zeus-components/lib/styled'

import { Icon } from '../icons'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 22;
  height: 100%;
  backdrop-filter: blur(4px);
  background: #2e2e2e;
  opacity: ${(p) => p.opacity};
  transition: opacity ease 0.5s;
`

const Modal = styled.div`
  background: #fff;
  z-index: 40;
  text-align: left;
  padding: ${prop('theme.body.padding')};
  opacity: ${(p) => p.opacity};
  transition: opacity ease 0.5s;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 40vh;
  width: 90%;
  max-width: 600px;
  border-radius: 10px;

  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    padding: 20px ${prop('theme.body.padding')};
    width: 50%;
    max-width: 600px;
  }

  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    padding: 20px 40px;
  }
`

const TopRightModal = styled.div`
  background: #fff;
  z-index: 40;
  text-align: left;
  padding: ${prop('theme.body.padding')};
  opacity: ${(p) => p.opacity};
  transition: opacity ease 0.5s;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  max-width: 100%;
  height: 100vh;

  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    padding: 29px 34px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
`

const Close = styled.button`
  position: absolute;
  top: 23px;
  right: 21px;
  padding: 0;
  margin: 0;

  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    right: 30px;
  }
`

const ModalOverlay = ({
  onClose,
  showCloseButton = true,
  showTopRight = false,
  children,
}) => {
  const overlayRef = useRef()
  const modalRef = useRef()
  const [opacity, setOpacity] = useState(0)

  const handleOverlayClick = (e) => {
    if (overlayRef.current === e.target) {
      onClose()
    }
  }

  useEffect(() => {
    setOpacity(1)
  }, [])

  const ModalComponent = showTopRight ? TopRightModal : Modal

  return (
    <Overlay
      ref={overlayRef}
      onClick={handleOverlayClick}
      opacity={opacity}
    >
      <ModalComponent ref={modalRef}>
        {showCloseButton && (
          <Close onClick={onClose}>
            <Icon name="x" width="24px" height="24px" />
          </Close>
        )}
        {children}
      </ModalComponent>
    </Overlay>
  )
}

ModalOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
  showTopRight: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default ModalOverlay
